import { getRuntimeConfig } from "./runtimeConfig";

/** Runtime variable of each feature flag. */
export const FEATURE_FLAGS = {
  /** Sales report v1: the client-side report grid running on mock data. */
  SALES_REPORT_V1: "REACT_APP_SALES_REPORT_V1_DISABLED",
} as const;

export type FeatureFlag = keyof typeof FEATURE_FLAGS;

/**
 * Feature flags read from the runtime configuration.
 *
 * Deployed environments get their values from Helm runtimeConfig
 * (ConfigMap → container environment → window.__RUNTIME_CONFIG__).
 *
 * Disabled-convention flags are enabled by default.
 *
 * - "true"        → disabled
 * - "false"       → enabled
 * - missing/empty → enabled
 */
export class FeatureFlags {
  constructor(
    private readonly read: (name: string) => string = getRuntimeConfig,
  ) {}

  isEnabled(flag: FeatureFlag): boolean {
    const value = (this.read(FEATURE_FLAGS[flag]) ?? "").trim().toLowerCase();

    return value !== "true";
  }
}

export const featureFlags = new FeatureFlags();
